<fieldset [disabled]="disabled" class="bb-fieldset">
  @if (heading) {
    <legend class="bb-fieldset__heading">
      {{ heading }}
    </legend>
  }
  <ng-content></ng-content>
</fieldset>
